import r from "../managers/braze-instance.js";
import Z from "./content-cards-provider-factory.js";
export function subscribeToContentCardsUpdates(o) {
  if (!r.rr()) return;
  const t = Z.m(),
    n = t.qt(o);
  if (!t.Ct()) {
    const o = r.nn();
    if (o) {
      const r = o.rn(() => {
        t.Ci(void 0, void 0, !0);
      });
      r && t.Tt(r);
    }
  }
  return n;
}
